module.exports = __webpack_public_path__ + "images/dummyuser.319d0ad457a9128276e6.png";